import { render } from "./HeroiconsOutlineAdjustments.vue?vue&type=template&id=781000d7"
const script = {}

import exportComponent from "/var/www/vacation-system/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineAdjustments.vue"]])

export default __exports__